export const environment = {
    production: false,
    title: 'Dev Environment',
    hostURL:'https://wwwdrt.idev.fedex.com',
    apiURL:'https://dev.fdmpnoptout.fedex.com/optOutService',
    apifURL: 'https://apidrt.idev.fedex.com/',
    host:'wwwdrt.idev.fedex.com',
    apigURL:'apidrt.idev.fedex.com',
    clientId:'l779d92200c5aa4ab0b2cc105e3a25ebf6'
  };